module.exports = __webpack_public_path__ + "img/titlebg.f54d211f.png";